import React from 'react';
import Link from 'next/link';
import BaseLayout from '@/components/layouts/BaseLayout';
import BasePage from '@/components/BasePage';
import { useRouter } from 'next/router';
import BasicVaccineLink from '@/Handlers/BasicVaccineLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Container } from 'reactstrap';
import Booking from '@/components/Booking';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';

export const Mumps = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.mumps.title')}
						vaccine='mumps'
						what_is={1}
						can_be_vaccinated={2}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.mumps.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.mumps.title'
						).toLowerCase()}`}
						more={true}
						vaccine='mumps'
						what_is={1}
						can_be_vaccinated={2}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Haemophilus = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.haemophilus.title')}
						vaccine='haemophilus'
						what_is={1}
						can_be_vaccinated={1}
						occurrence={2}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.haemophilus.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.haemophilus.title'
						).toLowerCase()}`}
						more={true}
						vaccine='haemophilus'
						what_is={1}
						can_be_vaccinated={1}
						occurrence={2}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const HPV = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.hpv.title')}
						vaccine='hpv'
						what_is={2}
						can_be_vaccinated={2}
						protection={2}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.hpv.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.hpv.title'
						).toLowerCase()}`}
						more={true}
						vaccine='hpv'
						what_is={2}
						can_be_vaccinated={2}
						protection={2}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Flu = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.flu.title')}
						vaccine='flu'
						what_is={4}
						can_be_vaccinated={4}
						protection={1}
						occurrence={2}
						source={1}
					/>
				</h3>
				<p>
					{t('vaccines.flu.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.flu.title'
						).toLowerCase()}`}
						more={true}
						vaccine='flu'
						what_is={4}
						can_be_vaccinated={4}
						protection={1}
						occurrence={2}
						source={1}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const WhoopplingCough = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.whooppling_cough.title')}
						vaccine='whooppling_cough'
						what_is={3}
						can_be_vaccinated={2}
						protection={1}
						source={1}
					/>
				</h3>
				<p>
					{t('vaccines.whooppling_cough.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.whooppling_cough.title'
						).toLowerCase()}`}
						more={true}
						vaccine='whooppling_cough'
						what_is={3}
						can_be_vaccinated={2}
						protection={1}
						source={1}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Measels = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.measels.title')}
						vaccine='measels'
						what_is={3}
						can_be_vaccinated={3}
						occurrence={2}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.measels.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.measels.title'
						).toLowerCase()}`}
						more={true}
						vaccine='measels'
						what_is={3}
						can_be_vaccinated={3}
						occurrence={2}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Polio = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.polio.title')}
						vaccine='polio'
						what_is={2}
						can_be_vaccinated={3}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.polio.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.polio.title'
						).toLowerCase()}`}
						more={true}
						vaccine='polio'
						what_is={2}
						can_be_vaccinated={3}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Rotavirus = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.rotavirus.title')}
						vaccine='rotavirus'
						what_is={3}
						can_be_vaccinated={2}
						occurrence={3}
						source={4}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.rotavirus.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.rotavirus.title'
						).toLowerCase()}`}
						more={true}
						vaccine='rotavirus'
						what_is={3}
						can_be_vaccinated={2}
						occurrence={3}
						source={4}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Rubella = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.rubella.title')}
						vaccine='rubella'
						what_is={2}
						can_be_vaccinated={2}
						occurrence={1}
						source={2}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.rubella.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.rubella.title'
						).toLowerCase()}`}
						more={true}
						vaccine='rubella'
						what_is={2}
						can_be_vaccinated={2}
						occurrence={1}
						source={2}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const ChickenPox = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.chicken_pox.title')}
						vaccine='chicken_pox'
						what_is={4}
						can_be_vaccinated={3}
						protection={1}
						occurrence={1}
						source={2}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.chicken_pox.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.chicken_pox.title'
						).toLowerCase()}`}
						more={true}
						vaccine='chicken_pox'
						what_is={4}
						can_be_vaccinated={3}
						protection={1}
						occurrence={1}
						source={2}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const HepatitisA = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.hepatitis_a.title')}
						vaccine='hepatitis_a'
						what_is={3}
						can_be_vaccinated={5}
						protection={1}
						occurrence={2}
						source={2}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.hepatitis_a.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.hepatitis_a.title'
						).toLowerCase()}`}
						more={true}
						vaccine='hepatitis_a'
						what_is={3}
						can_be_vaccinated={5}
						protection={1}
						occurrence={2}
						source={2}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const HepatitisB = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.hepatitis_b.title')}
						vaccine='hepatitis_b'
						what_is={10}
						can_be_vaccinated={3}
						occurrence={2}
						source={7}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.hepatitis_b.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.hepatitis_b.title'
						).toLowerCase()}`}
						more={true}
						vaccine='hepatitis_b'
						what_is={10}
						can_be_vaccinated={3}
						occurrence={2}
						source={7}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Diphtheria = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.diphtheria.title')}
						vaccine='diphtheria'
						what_is={3}
						can_be_vaccinated={3}
						protection={1}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.diphtheria.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.diphtheria.title'
						).toLowerCase()}`}
						more={true}
						vaccine='diphtheria'
						what_is={3}
						can_be_vaccinated={3}
						protection={1}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const TBE = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.tbe.title')}
						vaccine='tbe'
						what_is={4}
						can_be_vaccinated={3}
						protection={2}
						occurrence={1}
						source={1}
					/>
				</h3>
				<p>
					{t('vaccines.tbe.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.tbe.title'
						).toLowerCase()}`}
						more={true}
						vaccine='tbe'
						what_is={4}
						can_be_vaccinated={3}
						protection={2}
						occurrence={1}
						source={1}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const YellowFever = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.yellow_fever.title')}
						vaccine='yellow_fever'
						what_is={1}
						can_be_vaccinated={7}
						protection={1}
						occurrence={1}
						source={1}
					/>
				</h3>
				<p>
					{t('vaccines.yellow_fever.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.yellow_fever.title'
						).toLowerCase()}`}
						more={true}
						vaccine='yellow_fever'
						what_is={1}
						can_be_vaccinated={7}
						protection={1}
						occurrence={1}
						source={1}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const JapaneseBrainInflammation = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.japanese_brain_inflammation.title')}
						vaccine='japanese_brain_inflammation'
						what_is={2}
						can_be_vaccinated={2}
						protection={1}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.japanese_brain_inflammation.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.japanese_brain_inflammation.title'
						).toLowerCase()}`}
						more={true}
						vaccine='japanese_brain_inflammation'
						what_is={2}
						can_be_vaccinated={2}
						protection={1}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Cholera = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.cholera.title')}
						vaccine='cholera'
						what_is={1}
						can_be_vaccinated={1}
						protection={1}
						occurrence={1}
						source={3}
					/>
				</h3>
				<p>
					{t('vaccines.cholera.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.cholera.title'
						).toLowerCase()}`}
						more={true}
						vaccine='cholera'
						what_is={1}
						can_be_vaccinated={1}
						protection={1}
						occurrence={1}
						source={3}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Malaria = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.malaria.title')}
						vaccine='malaria'
						what_is={2}
						protection={5}
						occurrence={2}
						source={1}
					/>
				</h3>
				<p>
					{t('vaccines.malaria.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.malaria.title'
						).toLowerCase()}`}
						more={true}
						vaccine='malaria'
						what_is={2}
						protection={5}
						occurrence={2}
						source={1}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const MeningococcalDiseases = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.meningococcal_diseases.title')}
						vaccine='meningococcal_diseases'
						what_is={1}
						can_be_vaccinated={5}
						occurrence={1}
						source={1}
					/>
				</h3>
				<p>
					{t('vaccines.meningococcal_diseases.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.meningococcal_diseases.title'
						).toLowerCase()}`}
						more={true}
						vaccine='meningococcal_diseases'
						what_is={1}
						can_be_vaccinated={5}
						occurrence={1}
						source={1}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const PneumococcalDiseases = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.pneumococcal_diseases.title')}
						vaccine='pneumococcal_diseases'
						what_is={1}
						can_be_vaccinated={3}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.pneumococcal_diseases.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.pneumococcal_diseases.title'
						).toLowerCase()}`}
						more={true}
						vaccine='pneumococcal_diseases'
						what_is={1}
						can_be_vaccinated={3}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Tetanus = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.tetanus.title')}
						vaccine='tetanus'
						what_is={1}
						can_be_vaccinated={4}
						protection={1}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.tetanus.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.tetanus.title'
						).toLowerCase()}`}
						more={true}
						vaccine='tetanus'
						what_is={1}
						can_be_vaccinated={4}
						protection={1}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Tuberculosis = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.tuberculosis.title')}
						vaccine='tuberculosis'
						what_is={1}
						can_be_vaccinated={2}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</h3>
				<p>
					{t('vaccines.tuberculosis.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.tuberculosis.title'
						).toLowerCase()}`}
						more={true}
						vaccine='tuberculosis'
						what_is={1}
						can_be_vaccinated={2}
						occurrence={1}
						source={1}
						kids={true}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Typhoid = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.typhoid.title')}
						vaccine='typhoid'
						what_is={1}
						can_be_vaccinated={3}
						protection={1}
						occurrence={1}
						source={2}
					/>
				</h3>
				<p>
					{t('vaccines.typhoid.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.typhoid.title'
						).toLowerCase()}`}
						more={true}
						vaccine='typhoid'
						what_is={1}
						can_be_vaccinated={3}
						protection={1}
						occurrence={1}
						source={2}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Rabies = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.rabies.title')}
						vaccine='rabies'
						what_is={2}
						can_be_vaccinated={6}
						protection={3}
						occurrence={1}
						source={1}
					/>
				</h3>
				<p>
					{t('vaccines.rabies.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.rabies.title'
						).toLowerCase()}`}
						more={true}
						vaccine='rabies'
						what_is={2}
						can_be_vaccinated={6}
						protection={3}
						occurrence={1}
						source={1}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};
export const Shingrix = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.shingrix.title')}
						vaccine='shingrix'
						what_is={1}
						can_be_vaccinated={2}
						protection={1}
						occurrence={1}
						source={2}
					/>
				</h3>
				<p>
					{t('vaccines.shingrix.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.shingrix.title'
						).toLowerCase()}`}
						more={true}
						vaccine='shingrix'
						what_is={3}
						can_be_vaccinated={4}
						protection={1}
						occurrence={2}
						source={2}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Prevenar20 = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.prevenar20.title')}
						vaccine='prevenar20'
						what_is={1}
						can_be_vaccinated={2}
						protection={1}
						occurrence={1}
						source={2}
					/>
				</h3>
				<p>
					{t('vaccines.prevenar20.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.prevenar20.title'
						).toLowerCase()}`}
						more={true}
						vaccine='prevenar20'
						what_is={3}
						can_be_vaccinated={4}
						protection={1}
						occurrence={2}
						source={2}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

export const Qdenga = ({ t }) => {
	return (
		<React.Fragment>
			<Col md='6'>
				<h3 className='page_subtext vaccines-header text-uppercase'>
					<BasicVaccineLink
						title={t('vaccines.qdenga.title')}
						vaccine='qdenga'
						what_is={1}
						can_be_vaccinated={2}
						protection={1}
						occurrence={1}
						source={2}
					/>
				</h3>
				<p>
					{t('vaccines.qdenga.description')}
					<br />
					<BasicVaccineLink
						title={`${t('vaccines.read_more')}${t('vaccines.about')}${t(
							'vaccines.qdenga.title'
						).toLowerCase()}`}
						more={true}
						vaccine='qdenga'
						what_is={3}
						can_be_vaccinated={4}
						protection={1}
						occurrence={2}
						source={2}
					/>
				</p>
			</Col>
		</React.Fragment>
	);
};

const VaccineList = ({ t }) => {
	return (
		/* Base Page - Shared component with Container */
		<BasePage id='information-page' className='information-page'>
			<Container>
				{useRouter().pathname == '/vaccines' ? (
					<React.Fragment>
						<h1 className='page_text font-weight-bold text-center'>{t('navbar.vaccines')}</h1>
						<h2 className='page_subtext text-uppercase text-center'>
							<Link passHref href='/recommendations'>
								<a>
									{t('authorities.title')} <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
								</a>
							</Link>
						</h2>
					</React.Fragment>
				) : (
					<React.Fragment>
						<h2 className='page_text font-weight-bold text-center'>{t('navbar.vaccines')}</h2>
						<p className='page_subtext text-uppercase text-center'>
							<Link passHref href='/recommendations'>
								<a>
									{t('authorities.title')} <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
								</a>
							</Link>
						</p>
					</React.Fragment>
				)}

				<hr className='vaccination-page_hr' />
				<Row>
					<Mumps t={t} />
					<Haemophilus t={t} />

					<HPV t={t} />
					<Flu t={t} />
				</Row>
				<Row>
					<WhoopplingCough t={t} />
					<Measels t={t} />

					<Polio t={t} />
					<Rotavirus t={t} />
				</Row>
				<Row>
					<Rubella t={t} />
					<ChickenPox t={t} />

					<HepatitisA t={t} />
					<HepatitisB t={t} />
				</Row>
				<Booking />
				<Row>
					<Diphtheria t={t} />
					<TBE t={t} />

					<YellowFever t={t} />
					<JapaneseBrainInflammation t={t} />
				</Row>
				<Row>
					<Cholera t={t} />
					<Malaria t={t} />

					<MeningococcalDiseases t={t} />
					<PneumococcalDiseases t={t} />
				</Row>
				<Row>
					<Tetanus t={t} />
					<Tuberculosis t={t} />

					<Typhoid t={t} />
					<Rabies t={t} />
				</Row>
				<Row>
					<Shingrix t={t} />
					<Prevenar20 t={t} />

					<Qdenga t={t} />
				</Row>
				<Booking />
			</Container>
		</BasePage>
	);
};

const Vaccines = ({ t }) => {
	return useRouter().pathname == '/vaccines' ? (
		//React.Fragment is used instead of <div> or <> to hide it from source
		<React.Fragment>
			<BaseLayout
				className='cover'
				title={t('navbar.vaccines')}
				description={`${t('authorities.text1')} ${t('authorities.text2')} ${t(
					'authorities.text3'
				)}`}
				keywords={`${t('SEO.keywords_common')} ${t('SEO.keywords_vaccines')}`}
				canonical='/vaccines'
			>
				<VaccineList t={t} />
			</BaseLayout>
		</React.Fragment>
	) : (
		<VaccineList t={t} />
	);
};
export default translate(Vaccines);
